import { render, staticRenderFns } from "./AmountPrevious.vue?vue&type=template&id=1bf158ce"
import script from "./AmountPrevious.vue?vue&type=script&lang=js"
export * from "./AmountPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports